import * as React from 'react'

import { type CheckboxProps } from '@material-ui/core/Checkbox/'

import { CheckboxLabelStyled } from './styles/CheckboxLabelStyled'
import { CheckboxStyled } from './styles/CheckboxStyled'
import { Icon } from '../Icon'
import { Space } from '../Space'
import { SubText } from '../Text'

export interface ICheckboxProps extends CheckboxProps {}

export const Checkbox = (props: React.PropsWithChildren<ICheckboxProps>) => {
  const { children, checked = false, id, disabled, ...otherProps } = props

  const baseCheckbox = (
    <Space size='small' direction='horizontal' align='baseline'>
      <CheckboxStyled
        id={id}
        disableRipple={true}
        color='default'
        icon={<></>}
        checkedIcon={<Icon icon='checkmark' bold />}
        indeterminateIcon={<Icon icon='times' bold />}
        aria-checked={checked}
        checked={checked}
        disabled={disabled}
        {...otherProps}
      />
      {children && <SubText>{children}</SubText>}
    </Space>
  )

  if (id) {
    return (
      <CheckboxLabelStyled htmlFor={id} disabled={disabled}>
        {baseCheckbox}
      </CheckboxLabelStyled>
    )
  }

  return baseCheckbox
}
Checkbox.displayName = 'Checkbox'
